import { type CompanyConfig, TimeFormat } from '../interface';

export const DubaiExpressComConfig: CompanyConfig = {
  id: 'f19a52e4-94dd-4203-8c52-c8265b076624',
  lang: 'en',
  langs: ['en'],
  name: 'DubaiExpressCom',
  nameSecondary: 'DubaiExpressCom',
  currency: 'AED',
  currencyCode: 'AED',
  officialName: 'Dubai Express',
  features: {
    forceLanguage: 'en',
    useDefaultWarehouseWhenMissing: true,
    useIntegerCurrency: true,
    insertGridFeedbackInProductsGrid: true,
    header: {
      showOrders: true,
      showAddress: true,
      showUserActions: true,
      showBanners: false,
    },
    productCard: {
      variantL: 'l',
      variantXL: 'xl',
      recommendationsVariant: 'l',
    },
  },
  email: 'info@dubaiexpress.com',
  feedbackEmail: 'info@dubaiexpress.com',
  marketingEmail: 'marketing@dubaiexpress.com',
  phonePlaceholder: '+971',
  defaultPhoneCode: '+971',
  phoneNumber: '+971 XXX XXX XXX',
  ageRestricted: 0,
  timeZone: 'Asia/Dubai',
  minimalOrderFeeThreshold: 700,
  address: 'Dubai, UAE',
  canonical: 'https://dubaiexpress.com',
  defaultVolumeDisplay: '1x',
  showCookieBanner: true,
  warehouse: {
    default: 'Test2',
    minimalOrderFeeWarehouseCodes: [],
    location: {
      lat: 25.2261783,
      lng: 55.363057,
    },
  },
  map: {
    center: { lat: 24.828866, lng: 54.881318 },
    zoom: 9,
  },
  paymentMethods: [],
  availablePaymentMethods: ['stripe'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    tg: 'https://t.me/dubaidutyfree_telegram',
    vk: 'https://vk.ru/dubaidutyfree',
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      paymentAndDeliveryPolicy: {
        label: 'paymentAndDeliveryPolicy',
        link: '/legals#payment-and-delivery',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      salesAndReturnPolicy: {
        label: 'salesAndReturnPolicy',
        link: '/legals#sales-and-returns-policies-and-consumer',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: 'REFERRAL_CODE',
    discount: '15%',
    minBasket: '15',
    downloadAppLink: 'https://...',
  },
  appStoreUrl: {
    ios: 'https://apps.apple.com/...',
    android: 'https://play.google.com/...',
  },
  apis: {
    yaMetrika: {
      token: 106451003,
    },
  },
  countryCode: 'AE',
  license: {
    name: '',
    numberPrinary: '',
    numberSecondary: '',
  },
};
